import { render, staticRenderFns } from "./DetailsInformationFundInvent.vue?vue&type=template&id=7d59255d&"
import script from "./DetailsInformationFundInvent.vue?vue&type=script&lang=js&"
export * from "./DetailsInformationFundInvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports